import Vue from 'vue'
// resources
import UserResource from '../../resources/user'
// components & views
import AutoComplete from '../../components/Autocomplete.vue'
import FormResourceEdit from '../../components/form_resource_edit/FormResourceEdit.vue'
import userFormSet from '../../resources/formsets/user'
// mixins
import modalMixin from '../../mixins/modal'
import toastMixin from '../../mixins/toast'

export default Vue.extend({
    data() {
        return {
            autoCompleteResource: null,
            selectedResource: null,
            isUpdatingUser: false,
        }
    },
    computed: {
        formsets() {
            return {
                userFormSet,
            }
        },
    },
    mixins: [modalMixin, toastMixin],
    components: {
        AutoComplete,
        FormResourceEdit,
    },
    methods: {
        displayUpdateUserForm() {
            this.showModal('update-user')
        },
        userSelectedResource(selectedUserResource) {
            if (selectedUserResource) {
                this.selectedResource = selectedUserResource
            }
        },
        updateUser() {
            let errors = this.selectedResource.validate()

            if (errors.length) {
                this.handleErrors(errors)
            } else {
                this.isUpdatingUser = !this.isUpdatingUser
                this.selectedResource
                    .save()
                    .then((result) => {
                        if (result.response.status > 200 || result.response.status < 299) {
                            this.createToast('b-toaster-top-center', 'success', true, 'User updated', `User with id ${this.selectedResource.attributes.id} was updated`)
                        }
                    })
                    .catch(() => {
                        this.createToast('b-toaster-top-center', 'danger', true, 'User was not updated', `Error updating user with id ${this.recentlyCreatedUserId}`)
                    })
                    .finally(() => {
                        this.isUpdatingUser = !this.isUpdatingUser
                    })
            }
        },
    },
    mounted() {
        this.autoCompleteResource = UserResource
    },
})
